// extracted by mini-css-extract-plugin
module.exports = {"logo":"styles_logo__3RYtH","logout":"styles_logout__KfWBB"};